module.exports = __webpack_public_path__ + "img/solution3.5d7057fe.png";